import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from '../ui/Button';
import { locations } from '../../data/locations';
interface LocationContactFormProps {
  preselectedLocationId: string;
}
export function LocationContactForm({
  preselectedLocationId
}: LocationContactFormProps) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    location: preselectedLocationId,
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact-form" className="py-16 bg-white" data-id="element-533">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-534">
        <div className="text-center mb-12" data-id="element-535">
          <div className="inline-flex items-center justify-center p-3 bg-slate-100 rounded-full mb-4" data-id="element-536">
            <Mail className="h-6 w-6 text-[#dc2626]" data-id="element-537" />
          </div>
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-538">
            Contact This Location
          </h2>
          <p className="text-slate-600" data-id="element-539">
            Have questions? Fill out the form below and we'll get back to you as
            soon as possible.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-50 rounded-xl border border-slate-200 p-8" data-id="element-540">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-541">
            <div data-id="element-542">
              <label htmlFor="firstName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-543">
                First Name *
              </label>
              <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-544" />
            </div>

            <div data-id="element-545">
              <label htmlFor="lastName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-546">
                Last Name *
              </label>
              <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-547" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-548">
            <div data-id="element-549">
              <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-550">
                Phone Number *
              </label>
              <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-551" />
            </div>

            <div data-id="element-552">
              <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-553">
                Email *
              </label>
              <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-554" />
            </div>
          </div>

          <div className="mb-6" data-id="element-555">
            <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-556">
              Preferred Location *
            </label>
            <select id="location" name="location" required value={formData.location} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" data-id="element-557">
              {locations.map(location => <option key={location.id} value={location.id} data-id="element-558">
                  {location.name}
                </option>)}
            </select>
          </div>

          <div className="mb-6" data-id="element-559">
            <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-560">
              Message (Optional)
            </label>
            <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="Tell us about your goals or ask any questions..." data-id="element-561" />
          </div>

          <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-562">
            Send Message
          </Button>
        </form>
      </div>
    </section>;
}